<template>
  <UserDetail />
</template>

<script>
import UserDetail from '../../../components/user/index'
export default {
  components: {
    UserDetail,
  },
}
</script>

<style scoped lang="scss">
</style>